<template>
  <router-view v-if="!isLoading" />
</template>

<script setup>
import { useCookies } from 'vue3-cookies';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

const { cookies } = useCookies();
const store = useStore();
const apiUrl = store.getters.getApiUrl;

const isLoading = ref(true); 

onMounted(async () => {
  const rawUser = cookies.get("user");

  if (rawUser) {
    try {
      const { id, bearer } = rawUser;

      const formData = new FormData();
      formData.append('action', `users/${id}`);
      formData.append('method', 'GET');
      formData.append('token', bearer);

      const response = await axios.post(apiUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log("response", response);
      
      store.commit("setUser", response.data);
    } catch (err) {
      console.error("Ошибка при загрузке пользователя:", err);
    }
  }

  isLoading.value = false;
});
</script>

<style>

</style>
